const zh = {
  // 顶部导航
  headerMsg: {
    navList: [
      {
        label: '首页',
        path: 'home'
      },
      {
        label: '产品中心',
        path: 'product',
        children: [
          {
            label: '鉴定服务',
            path: '/products/paternity-testing'
          },
          // {
          //   label: '新冠检测',
          //   path: '/products/ncov'
          // },
          {
            label: '肿瘤检测',
            path: '/products/tumour',
            children: [
              {
                label: '肺癌基因检测',
                path: '/products/tumour/lung'
              },
              {
                label: '妇科肿瘤基因检测',
                path: '/products/tumour/gynecological'
              },
              {
                label: '胃癌基因检测',
                path: '/products/tumour/stomach'
              },
              {
                label: '结直肠癌基因检测',
                path: '/products/tumour/CRC'
              },
              {
                label: '食管癌基因检测',
                path: '/products/tumour/esophagus'
              },
              {
                label: '遗传性肿瘤基因检测',
                path: '/products/tumour/hereditary'
              },
              {
                label: '胰腺癌基因检测',
                path: '/products/tumour/pancreas'
              },
              {
                label: '胃肠间质瘤基因检测',
                path: '/products/tumour/GIST'
              },
              {
                label: '实体瘤基因检测',
                path: '/products/tumour/solid'
              },
              {
                label: '术后微小残留病灶(MRD)监控',
                path: '/products/tumour/MRD'
              }
            ]
          },
          {
            label: '健康管理',
            path: '/products/hrgm',
            children: [
              {
                label: '遗传性肿瘤易感性筛查',
                path: '/products/hrgm/tumor_screening'
              },
              {
                label: '叶酸代谢',
                path: '/products/hrgm/folate_metabolism'
              },
              {
                label: '酒精代谢',
                path: '/products/hrgm/alcohol_metabolism'
              },
              {
                label: '运动基因',
                path: '/products/hrgm/motor_gene'
              }
            ]
          },
          {
            label: '病原微生物',
            path: '/products/mngs'
          }
        ]
      },
      {
        label: '肿瘤检测',
        path: 'detection',
        children: [
          {
            label: '肺癌基因检测',
            path: '/products/tumour/lung'
          },
          {
            label: '妇科肿瘤基因检测',
            path: '/products/tumour/gynecological'
          },
          {
            label: '胃癌基因检测',
            path: '/products/tumour/stomach'
          },
          {
            label: '结直肠癌基因检测',
            path: '/products/tumour/CRC'
          },
          {
            label: '食管癌基因检测',
            path: '/products/tumour/esophagus'
          },
          {
            label: '遗传性肿瘤基因检测',
            path: '/products/tumour/hereditary'
          },
          {
            label: '胰腺癌基因检测',
            path: '/products/tumour/pancreas'
          },
          {
            label: '胃肠间质瘤基因检测',
            path: '/products/tumour/GIST'
          },
          {
            label: '实体瘤基因检测',
            path: '/products/tumour/solid'
          },
          {
            label: '术后微小残留病灶(MRD)监控',
            path: '/products/tumour/MRD'
          }
        ]
      },
      // {
      //   label: '新冠检测',
      //   path: 'service'
      // },
      {
        label: '健康管理',
        path: 'hrgm',
        children: [
          {
            label: '遗传性肿瘤易感性筛查',
            path: '/products/hrgm/tumor_screening'
          },
          {
            label: '叶酸代谢',
            path: '/products/hrgm/folate_metabolism'
          },
          {
            label: '酒精代谢',
            path: '/products/hrgm/alcohol_metabolism'
          },
          {
            label: '运动基因',
            path: '/products/hrgm/motor_gene'
          }
        ]
      },
      {
        label: '新闻动态',
        path: 'news'
      },
      {
        label: '关于我们',
        path: 'about',
        children: [
          {
            path: '/about/aboutbt',
            label: '关于蓝沙'
          },
          {
            path: '/about/productCenter',
            label: '产品中心'
          },
          {
            path: '/about/platfrom',
            label: '公司优势'
          },
          // {
          //   path: '/about/patent',
          //   label: '产权专利'
          // },
          {
            path: '/about/certifications',
            label: '资质证书'
          }
        ]
      },
      {
        label: '加入我们',
        path: 'contact'
      }
    ],
    navigation: {
      paternity: '亲缘关系鉴定',
      service: '新冠核酸检测',
      tumour: '肿瘤用药基因检测',
      pathogenic: '病原微生物检测',
      sequencing: '健康风险基因管理',
      about: [
        {
          id: 'aboutbt',
          title: '关于蓝沙'
        },
        {
          id: 'productCenter',
          title: '产品中心'
        },
        {
          id: 'platfrom',
          title: '公司优势'
        },
        // {
        //   id: 'patent',
        //   title: '产权专利'
        // },
        {
          id: 'certifications',
          title: '资质证书'
        }
      ]
    },
    swiper: [
      // {
      //   label: '首页',
      //   path: 'home',
      //   url: 'banner1.jpg'
      // },
      // {
      //   label: '亲缘',
      //   path: 'paternity',
      //   url: 'banner2.jpg'
      // },
      {
        label: '首页',
        path: 'home',
        url: 'banner9.jpg'
      },
      // {
      //   label: '病原',
      //   path: 'mngs',
      //   url: 'banner8.jpg'
      // },
      // {
      //   label: '新冠检测',
      //   path: 'service',
      //   url: 'banner4.jpg'
      // },
      // {
      //   label: '肿瘤检测',
      //   path: 'detection',
      //   url: 'banner5.jpg'
      // },
      // {
      //   label: '健康',
      //   path: 'hrgm',
      //   url: 'banner6.jpg'
      // },
      // {
      //   label: '加入我们',
      //   path: 'contact',
      //   url: 'banner7.jpg'
      // }
    ]
  },


  // 底部信息
  footerMsg: {
    // 地址1
    add1: '武汉市硚口区长丰街道丰逸路3号',
    // 地址2
    add2: '江苏省苏州市高新区竹园路209号苏州创业园3号楼',
    // 标题  在线客服
    title1: '在线客服',
    // 在线客服下面的内容
    online_text: [
      '让我们更近一些',
      '您可以',
      '拨打企业专线',
      '或者您还可以'
    ],
    // 咨询按钮
    zx: '点我咨询',
    // 标题  联系我们
    title2: '联系我们',
    // 姓名
    input_name: '姓名(必填)',
    // 手机
    input_tel: '手机(必填)',
    // 内容
    // input_con: '内容(必填)',
    input_con:'',
    // 提交留言按钮
    submit: '提交留言',
    // 备案
    com_info1: 'Copyright @ 2022 China All Rights Reserved   版本所有 ',
    com_info2: '上海蓝沙生物科技有限公司',

    // 备案系统链接
    record: '沪ICP备18046095号-1'

  },

  // 首页信息
  home: {
    // homeList: ['paternity', 'service', 'mngs',],
    homeList: ['paternity', 'mngs',],
    m_tel: [
      "咨询：400-000-0922",
      "业务：027-83086999",
      "售后：400-611-6196",
      "邮箱：info@biocsi.com",
      "官网：www.biocsi.com"
    ],
    report: '报告查询'
  },

  // 关于我们
  about: {
    // 关于我们内容
    bt_title1: '关于蓝沙',
    bt_title2: 'ABOUT US',
    // bt_con: '<p>蓝沙生物成立于2016年，是一家技术驱动型公司。蓝沙生物专注于基因高通量测序技术在临床医学上的转化应用，为医院、医检所、生物公司提供定制化检测服务，主要有无创亲子鉴定、亲缘关系鉴定、肿瘤用药基因检测、新冠核酸检测、病原体微生物检测等多项优势产品，用科技守卫生活。</p><p>蓝沙生物为上海高新技术企业，技术团队成员在国际顶级期刊发表论文10余篇，拥有多项发明专利及知识产权。公司总部位于上海，分别在武汉和苏州建设了医学检验实验室和分子生物学实验室，总面积2200平米。</p><p>旗下武汉蓝沙医学检验实验室(简称“蓝沙医检”)，为第三方医疗检测机构，下设细胞和分子遗传、病理和生化三个临床检验科目，提供专业的临床检测服务。蓝沙医检致力于打造区域化检测检验服务中心，提供一体化定制检测服务。</p><p>旗下苏州苏因智启生物科技有限公司(简称“苏因智启”)，设有分子生物学实验室，致力于高通量测序相关技术研发及科研服务。苏因智启与苏州大学、苏州大学相城机器人与智能装备研究院成立“蓝沙生命科学智能化装备创新中心”，推进“产、学、研”深度融合，共同助推智能装备在生物检测领域的创新应用与发展。</p>',
    // bt_con: '<p>蓝沙生物成立于2016年，是一家技术驱动型公司。蓝沙生物专注于基因高通量测序技术在临床医学上的转化应用，为医院、医检所、生物公司提供定制化检测服务，主要有无创亲子鉴定、亲缘关系鉴定、肿瘤用药基因检测、病原体微生物检测等多项优势产品，用科技守卫生活。</p><p>蓝沙生物为上海高新技术企业，技术团队成员在国际顶级期刊发表论文10余篇，拥有多项发明专利及知识产权。公司总部位于上海，分别在武汉和苏州建设了医学检验实验室和分子生物学实验室，总面积2200平米。</p><p>旗下武汉蓝沙医学检验实验室(简称“蓝沙医检”)，为第三方医疗检测机构，下设细胞和分子遗传、病理和生化三个临床检验科目，提供专业的临床检测服务。蓝沙医检致力于打造区域化检测检验服务中心，提供一体化定制检测服务。</p><p>旗下苏州苏因智启生物科技有限公司(简称“苏因智启”)，设有分子生物学实验室，致力于高通量测序相关技术研发及科研服务。苏因智启与苏州大学、苏州大学相城机器人与智能装备研究院成立“蓝沙生命科学智能化装备创新中心”，推进“产、学、研”深度融合，共同助推智能装备在生物检测领域的创新应用与发展。</p>',
    bt_con: '<p>上海蓝沙生物科技有限公司成立于2016年，是一家技术驱动型公司。蓝沙生物专注于基因高通量测序技术在临床医学上的转化应用，为医院、医检所、生物公司提供定制化检测服务，主要有无创亲子鉴定、亲缘关系鉴定、肿瘤用药基因检测、病原体微生物检测等多项优势产品，用科技守卫生活。</p><p>旗下武汉蓝沙医学检验实验室(简称“蓝沙医检”)，为第三方医疗检测机构，下设细胞和分子遗传、病理和生化三个临床检验科目，提供专业的临床检测服务。蓝沙医检致力于打造区域化检测检验服务中心，提供一体化定制检测服务。</p><p>旗下苏州蓝沙生物科技有限公司(简称“苏州蓝沙”)，设有分子生物学实验室，致力于高通量测序相关技术研发及科研服务。苏州蓝沙与苏州大学、苏州大学相城机器人与智能装备研究院成立“蓝沙生命科学智能化装备创新中心”，推进“产、学、研”深度融合，共同助推智能装备在生物检测领域的创新应用与发展。</p>',
    // 产品中心
    pc_title1: '产品中心',
    pc_title2: 'PRODUCTS',
    pc_con: [
      {
        bgi: 'linear-gradient(90deg, #f9f6eb 0%, #f8f5ed 100%)',
        bgc: '#d8452b',
        title: '病原微生物检测',
        link: '/products/mngs',
        text: '病原数据库覆盖16200种微生物，包括临床常见、罕见病原体，并随着流行病原谱的变化及文献报告更新。'
      },
      // {
      //   bgi: 'linear-gradient(90deg, #f7f5ed 0%, #f4f4f0 100%)',
      //   bgc: '#344860',
      //   title: '新冠核酸检测',
      //   link: '/products/ncov',
      //   text: '普通人群，无密切接触史，无明显症状(发热或呼吸道症状)；食品和环境样本。'
      // },
      {
        bgi: 'linear-gradient(90deg, #f4f4f0 0%, #f1f3f3 100%)',
        bgc: '#fbb11b',
        title: '肿瘤基因检测',
        link: '/products/tumour',
        text: '蓝沙生物特有的快速杂交捕获技术，能大幅缩减目标区域捕获的时间，加快加测周期，为您提供迅捷的基因检测服务。 '
      },
      {
        bgi: 'linear-gradient(90deg, #f1f2f3 0%, #eef2f6 100%)',
        bgc: '#3598dc',
        title: '亲缘关系检测',
        link: '/products/paternity-testing',
        text: '蓝沙生物采用基于二代DNA测序技术的亲子鉴定(简称“二代亲子鉴定”)。相对传统亲子鉴定技术，二代DNA测序技术具有更准确、更稳定、更安全、更早期、应用场景更广等特点。'
      },
      {
        bgi: 'linear-gradient(90deg, #eef2f6 0%, #ecf1f8 100%)',
        bgc: '#8ac628',
        title: '健康风险基因管理',
        link: '/products/hrgm',
        text: 'WES全外显子组测序技术，揭秘基因中隐藏的奥秘，对健康风险、癌症、遗传特征、营养代谢、运动健身等进行评估，全面掌握自己的健康。'
      }
    ],
    // 平台优势
    pf_title1: '公司优势',
    pf_title2: 'PLATFORM ADVANTAGE',
    pf_con: [
      {
        title: '项目经验丰富',
        text: `<p>1、亲缘鉴定年检量70000+，可进行无创产前亲子鉴定、隐私亲子鉴定、三代以内的亲缘关系鉴定。</p>
        <p style="display:none">2、新冠核酸检测年检量100000+</p>
        <p>2、肿瘤基因检测年检量20000+</p>`
      },
      // {
      //   title: '核心知识产权',
      //   text: `<p>16项亲缘鉴定、病原检测相关核心专利</p><p>46项高通量测序管理、实验、信息相关软著</p>`
      // },
      {
        title: '规范化实验管理',
        text: '项目综合实施，一次性选择，提供更匹配更专业的平台，规范化实验管理，项目推进更加高效。'
      }
    ],
    // 产权专利
    patent_title1: '产权专利',
    patent_title2: 'PATENT',
    // 资质证书
    cf_title1: '资质证书',
    cf_title2: 'QUALIFICATION'
  },

  // 新闻动态
  news: {
    title1: '新闻动态',
    title2: 'NEWS TRENDS',
    // 发布日期
    news_date: '发布日期：',
    // 前往详情
    'to_details': '前往详情',
    // 上一页
    'pre': '上一页',
    // 下一页
    'next': '下一页',
    // 上一篇
    'to_pre': '上一篇:',
    // 下一篇
    'to_next': '下一篇:'
  },

  // 产品中心
  products: {
    ncov: '新冠<br/>核酸检测',
    gene: '肿瘤<br/>用药基因检测',
    paternity: '亲缘关系鉴定',
    exome: '健康风险基因管理',
    metagenomic: '病原微生物检测'
  },

  // 亲缘关系鉴定
  paternity: {
    pc_connect: '如有需要，请填写下方信息联系我们。',
    m_connect: '如有需要，请点击咨询填写信息联系我们。',
    pt_con: '针对普通大众对于亲缘关系想要得到确切答案而开展的检测服务。我司可进行亲子鉴定、全同胞鉴定、半同胞鉴定、叔侄/姑侄/舅甥/姨甥关系鉴定、祖孙关系鉴定等。常见检测样本类型包括：血液/血痕、精斑、口腔试子、带毛囊的毛发、口香糖、牙刷、烟头、指甲等。',
    nppt_con: '怀孕满5周以上需要抽取孕妇10ml静脉血，男士可以提供常规样本（指甲、毛发、纯精斑等）进行亲子关系检测，全国省市线下都能就近安排取样，鉴定快速便捷，',
    pt_list: [
      {
        color: '#e60012',
        title: '咨询与知情同意',
      },
      {
        color: '#eb6029',
        title: '样本采集',
      },
      {
        color: '#f5ad16',
        title: '样本寄送',
      },
      {
        color: '#20a068',
        title: '实验检测',
      },
      {
        color: '#2ad4d6',
        title: '数据分析',
      },
      {
        color: '#405daa',
        title: '出具报告',
      },
      {
        color: '#5a3d5b',
        title: '咨询解答',
      }
    ]
  },

  // 新冠检测
  service: {
    con: '<b>检测原理：</b><p>以新型冠状病毒（COVID-19）基因组中开放读码框（ORF1ab）及编码核衣蛋白N基因的特异性保守序列为靶区域。进行靶标基因的设计；在荧光定量PCR仪上，应用实时荧光定量PCR检测技术，实现新型冠状病毒RNA精准检测。</p><b>适用场景：</b><p class="td">1、近期有出差、旅行需求，需根据各地疫情防控形势变化进行核酸检测。</p><p class="td">2、新入院患者及陪护人员（含急诊留观患者及陪护人员）需根据医院规定进行核酸检测。</p><p class="td">3、各类考试前需按考试通知需求提前进行核酸检测。</p><p class="td">4、社区筛查样本可集体送检进行核酸检测。</p><p class="td">5、进出口食品；肉类、海鲜水产等生鲜冷冻制品。</p><b></b><p>冠状病毒的编码基因是RNA，通过测定样本中是否含有新型冠状病毒基因，即可判断患者是否被感染。目前RNA检测主要依赖于逆转录实时荧光定量PCR（RT-PCR）技术，其具体步骤为采集样本、提取 RNA、逆转录成cDNA、PCR扩增、结果分析。为了尽快抓住新冠病毒的尾巴，频繁且多次进行核酸检测，可以更早发现新冠病毒的踪迹。'
  },
  urgentService: {
    con: `<p>为满足武汉部分市民特殊需求，蓝沙核酸检测中心贴心推出紧急核酸检测服务，只需2小时便可查询报告。方便、省时!检测出报告一步到位，即做即走，2小时后出电子版报告。方便出
    国、出省、搭乘飞机、火车、临时就医等需要出具近期核酸证明的人。蓝沙立检，方便无忧!</p>
    
    <b>加急核检测对象:</b>
    <p>无高风险区旅游史，无密切接触史，无明显症状(发热或呼吸道症状)且有紧急出行需求的市民</p>
    
    <b>加急核酸检测地点及时间: </b>
    <p>地点:武汉市硚口区工农路6号硚口区妇幼保健院12楼</p>
    <p>时间:工作日10:00-17:00 </p>
    
    <p>持本人身份证或健康码绿码，至硚口区公共卫生服务中心，乘坐电梯至12楼，前往武汉蓝沙护理站进行采样:两小时后即可在蓝沙生物公众号-报告查询-新冠核酸检测外输入本人正确身份证号码下载报告。</p>`
  },
  // 病原微生物检测
  mngs: {
    con: `
      <p>蓝沙病原微生物宏基因组检测基于二代测序的宏基因测序技术（mNGS），直接对样本中的核酸进行检测，获得样本中微生物的序列信息，无偏向性的鉴定可疑致病微生物，可覆盖细菌、真菌、病毒、寄生虫、分岐杆菌、支原体和衣原体等多种病原微生物，协助医生全面、快速、准确地对患者进行临床诊断和干预治疗。</p>
      <div class="bold">产品优势</div>
      <p><b>无需培养：</b>不需要进行传统的培养和纯化</p>
      <p><b>无需预设：</b>无需预测样本中的病原微生物</p>
      <p><b>无偏好性：</b>无偏好测序，可检测未知病原体 </p>
      <p><b>灵敏度高：</b>可检测高宿主背景下的病原体</p>
      <p><b>精准全面：</b>同时检测DNA和RNA；可检测耐药基因和毒力因子；一次可覆盖16200种病原微生物</p>
      <p><b>快速鉴定：</b>从样本质检合格到报告最快24h交付</p>
      <div class="bold">适用场景</div>
      <p><b>疑“难”患者：</b>不明原因发热、反复发热、 疑似新发病原体感染、 多重感染、治疗效果不佳等。</p>
      <p><b>危“重”患者：</b>重症肺炎、脑膜炎、脓毒症等。</p>
      <p><b>“特”殊患者：</b>器官移植、肿瘤患者等。</p>
    `
  },

  // 健康风险基因管理
  hrgm: {
    health: `<p>健康风险基因管理包含运动基因检测、叶酸代谢能力检测、酒精代谢能力检测和遗传性肿瘤易感基因筛查，旨在从基因层面了解自身身体状况，防控风险，并给予科学性的指导建议。</p>`,
    testing: {
      pics: [
        {
          mainColor: '#b993c4',
          src: require('@/assets/img/health/p1.png'),
          text: '遗传性肿瘤易感性筛查',
          english: 'SCREENING FOR HEREDITARY<br/>TUMOR SUSCEPTIBILITY',
          hoverSrc: require('@/assets/img/health/w1.png'),
          hoverArrow: require('@/assets/img/health/arrow2.png'),
          path: 'tumor_screening'
        },
        {
          mainColor: '#9fd0af',
          src: require('@/assets/img/health/p2.png'),
          text: '叶酸代谢',
          english: 'FOLATE METABOLISM',
          hoverSrc: require('@/assets/img/health/w2.png'),
          hoverArrow: require('@/assets/img/health/arrow3.png'),
          path: 'folate_metabolism'
        },
        {
          mainColor: '#f57983',
          src: require('@/assets/img/health/p3.png'),
          text: '酒精代谢',
          english: 'ALCOHOL METABOLISM',
          hoverSrc: require('@/assets/img/health/w3.png'),
          hoverArrow: require('@/assets/img/health/arrow4.png'),
          path: 'alcohol_metabolism'
        },
        {
          mainColor: '#eeaa57',
          src: require('@/assets/img/health/p4.png'),
          text: '运动基因',
          english: 'SPORTS GENE',
          hoverSrc: require('@/assets/img/health/w4.png'),
          hoverArrow: require('@/assets/img/health/arrow5.png'),
          path: 'motor_gene'
        }
      ],
      con: `<div class="bold">检测意义：</div>
      <p>每个人的DNA 中都储存着遗传信息，人与人之间的DNA大约有99.5% 相同。但是，存在使每个人都独一无二的细微差异。这些细微差异常常不超过基因的 0.5%，却与外貌、性格、健康风险、营养代谢、遗传特征等息息相关。通过对个人基因的解读，可以了解自身遗传特征，科学管理健康，预防高危风险，优化生活方式。</p>
      <div class="bold">检测样本：</div>
      <p>2ml唾液</p>`
    }
  },

  // 叶酸代谢
  folate: {
    gene: '参与叶酸代谢最重要的两个基因是亚甲基四氢叶酸还原酶基因（MTHFR）和甲硫氨酸合成酶还原酶基因（MTRR）。研究发现，MTHFR的活性与C677T和A1298C基因位点有关；MTRR的活性与A66G基因位点有关。当孕妇的基因位点发生突变时就会导致MTHFR和MTRR活性下降，进而引起叶酸利用能力不足，胎儿出生缺陷的风险增加。',
    mean: `
      <p>叶酸是B族维生素之一，在人体内不能合成，只能通过外源性摄入。叶酸是胚胎发育过程中不可缺少的营养素，在预防出生缺陷方面具有重要意义。叶酸缺乏可引起巨幼红细胞贫血，在妇女围孕期可导致胎儿神经管畸形、唇腭裂、心脏缺陷等。孕妇对叶酸的需求量比正常人高4倍，通过食物摄入的叶酸量远远不能满足需求，育龄妇女增补叶酸是优生优育相关措施的重要内容之一</p>
      <p style="margin-top:.59rem">因此了解自身叶酸代谢能力，并调整叶酸补充剂量的个体化医疗已经成为精准医学、合理使用叶酸的重要一环。</p>
      `,
    crowd: `
    <p>1、不良妊娠史的患者；</p>
    <p>2、有血栓家族史的备孕人群；</p>
    <p>3、合并免疫问题的孕妇；</p>
    <p>4、平时血液循环差，偏头疼，伤口出血少或易健忘的备孕人群。</p>
    <p>5、关注自身健康的人群</p>
      `,
    test: `
      <p>样本类型：2mL唾液</p>
      <p>检测周期：2工作日</p>
      `
  },

  // 酒精代谢
  alcohol: {
    con: `
    <p>酒文化的历史源远流长，已经成为人们日常社工或不可或缺的一部分。但是有的人千杯不醉，有的人一杯就倒，还有的人一喝酒就脸红。</p>
    <p>其实，酒量是基因决定的，酒量好是“与生俱来”的。</p>
    `,
    gene: `
    <p>饮酒后，酒精在乙醇脱氢酶（ADH）的作用下转变为乙醛，乙醛在乙醛脱氢酶（ALDH）的作用下转变为乙酸，乙酸（即醋酸）对人体无害，最终分解为水和二氧化碳。酒精进入人体后，首先被乙醇脱氢酶分解，ADH1B基因中的rs1229984位点的C等位基因显著影响了乙醇脱氢酶的活性，降低了酒精代谢速率。</p>
    <p>酒精被分解生成乙醛后，在乙醛脱氢酶的作用下分解生成乙酸，ALDH2基因中rs671的A等位基因影响了乙醛脱氢酶的活性，降低了乙醛代谢速率。</p>
    `,
    mean: '本项目通过二代测序检测酒精代谢中2个关键的酶ADH1B、ALDH2的基因型，以此评估其酒精代谢能力，同时给予科学性的饮酒建议，适度饮酒，防止酒精中毒和疾病发生。',
    crowd: `
    <p>1、长期喝酒应酬的人群</p>
    <p>2、关注自身健康人群</p>
    <p>3、酒量不佳人群</p>
    <p>4、饮酒后身体不适人群</p>
    `
  },

  // 运动基因
  sports: {
    gene: `
    <p>同样的健康指标，有的人经过运动健身很快就有很大的变化，有的人变化比较慢，还有的人则根本没有变化，这很大程度上是由遗传基因决定的。</p>
    <p style="text-align:right;">———美国运动生理学和遗传学家 克劳德·布查得博士</p>
    `,
    test: `
    <p>样本类型：2mL唾液</p>
      <p>检测周期：5-7工作日</p>
    `
  },

  tumor: {
    con1: '肿瘤的发生与遗传因素、环境因素以及生活习惯息息相关。遗传性肿瘤是指人体因特定基因生殖突变（胚系突变）导致罹患肿瘤，而这些带有致病突变的基因有50%的概率遗传给下一代，一旦下一代携带这个致病突变的基因，就具有较高的患病风险。',
    con2: '肿瘤易感性基因检测通过高通量测序技术对人体内的胚系突变基因进行筛查，找到与肿瘤遗传相关的突变基因，评估患癌风险，并为受检者提供具有针对性的健康管理方案。',
    crowd: `
    <p>1、高度关注自身健康的人群；</p>
    <p>2、家族中有多人患肿瘤；</p>
    <p>3、家族中有发病年龄较早的肿瘤患者（发病年龄小于30岁）;</p>
    <p>4、家族中有同一人罹患多种肿瘤疾病；</p>
    <p>5、患有某些慢性病人群（胰腺炎、乳腺增生等）;</p>
    <p>6、想确认是否为胚系突变（遗传性）的肿瘤患者。</p>
    `
  },

  // 肿瘤检测
  detection: {
    con: `<p>随着基因分子水平研究的不断深入，越来越多的肿瘤癌细胞和信号通路被发现，大量临床研究表明，通路中的特定基因的扩增/突变/表达状态与靶向、化疗药物的有效性密切相关。因此，临床上检测这些通路中特定基因的扩增/突变/表达情况，能针对性地为每位患者量身定做一套最适合的治疗方案，从而最大程度地提高治疗的有效率，减少药物的毒副作用，避免用药不当贻误治疗时机。</p><p>蓝沙肿瘤基因检测产品采用高通量测序技术，检测实体瘤靶向治疗、免疫治疗、化疗和遗传风险密切相关的基因。</p><b>检测意义：</b><p class='yy'>1、检测肿瘤患者生物样本的基因突变可选择靶向药物；靶向药物可识别肿瘤细胞特有基因的突变位点，通过与之结合(或者类似的其他机制），阻断肿瘤细胞内控制细胞生长、增殖的信号传导通路，从而杀灭肿瘤细胞、阻止其增殖。</p><p>2、化疗用药前进行相关基因SNP检测，选用对个体疗效好、毒副作用低的化疗药物，辅助优化化疗方案。</p><p>3、检测已报道的微卫星区域和免疫治疗相关基因，可提示免疫治疗疗效。</p><p>4、检测肠癌遗传相关风险基因(林奇综合征等)，提示家族遗传风险。</p>`,
    tp_list: ['患者咨询知情同意', '采集样本', '样本寄送和接收', '测序分析', '报告解读和咨询'],
    // 主体介绍
    main: [
      {
        name: "solid",
        icon: {
          w: '.83rem',
          h: '.71rem',
          t: '.44rem',
        },
        top: '3.26rem',
        left: '1.49rem',
        title: '实体瘤基因检测',
      },
      {
        name: "lung",
        icon: {
          w: '.82rem',
          h: '.8rem',
          t: '.24rem',
        },
        top: '1.92rem',
        left: '3.74rem',
        title: '肺癌基因检测',
        content: 'NCCN靶向基因全覆盖，包含肺癌15基因检测及肺癌27基因检测'
      },
      {
        name: "stomach",
        icon: {
          w: '.76rem',
          h: '.73rem',
          t: '.42rem',
        },
        top: '4.56rem',
        left: '3.76rem',
        title: '胃癌基因检测',
        content: 'NCCN靶向基因全覆盖，包含胃癌60基因检测'
      },
      {
        name: "gynecological",
        icon: {
          w: '.84rem',
          h: '.73rem',
          t: '.32rem',
        },
        top: '7.2rem',
        left: '3.81rem',
        title: '妇科肿瘤基因检测',
        content: 'NCCN靶向基因全覆盖，包含乳腺癌、卵巢癌等相关的70基因检测'
      },
      {
        name: "hereditary",
        icon: {
          w: '.75rem',
          h: '.75rem',
          t: '.45rem',
        },
        top: '8.55rem',
        left: '1.56rem',
        title: '遗传性<br />肿瘤基因检测',
      },
      {
        name: "esophagus",
        icon: {
          w: '.74rem',
          h: '.63rem',
          t: '.42rem',
        },
        top: '1.88rem',
        left: '8.31rem',
        title: '食管癌基因检测',
        content: 'NCCN靶向基因全覆盖，包含52基因检测'
      },
      {
        name: "GIST",
        icon: {
          w: '.58rem',
          h: '0.97rem',
          t: '.28rem',
        },
        top: '3.16rem',
        left: '10.62rem',
        title: '胃肠间质瘤基因检测',
        content: 'NCCN靶向基因全覆盖，包含胃肠间质瘤34基因检测'
      },
      {
        name: "pancreas",
        icon: {
          w: '.86rem',
          h: '.34rem',
          t: '.42rem',
        },
        top: '4.51rem',
        left: '8.35rem',
        title: '胰腺癌<br />基因检测',
        content: 'NCCN靶向基因全覆盖，包含胰腺癌60基因检测'
      },
      {
        name: "CRC",
        icon: {
          w: '.73rem',
          h: '.76rem',
          t: '.42rem',
        },
        top: '7.13rem',
        left: '8.38rem',
        title: '结直肠癌基因检测',
        content: 'NCCN靶向基因全覆盖，包含结直肠癌60基因检测'
      },
      {
        name: "MRD",
        icon: {
          w: '.69rem',
          h: '.69rem',
          t: '.36rem',
        },
        top: '8.42rem',
        left: '10.67rem',
        title: '术后<br />微小残留病灶<br />（MRD）监控'
      }
    ]
  },

  // 肿瘤详情
  d_detail: [
    {
      id: 1,
      name: "solid",
      next_id: 2,
      title: '实体瘤基因检测',
      img: 5,
      size: { w: '.61rem', h: '.52rem', t: 0, r: '0.59rem' },
      t1: '实体瘤580基因检测',
      t2: '实体瘤120基因检测',
      c1: `<p>实体瘤580基因检测产品采用高通量测序技术，检测实体瘤靶向治疗、免疫治疗、化疗和遗传风险相关的580个基因，全面评估130余种靶向药物和30余种化疗药物单药及联合治疗方案疗效，同时通过微卫星不稳定（MSI）、肿瘤突变负荷（TMB）、肿瘤新抗原预测以及免疫系统相关基因检测评估免疫治疗疗效；评估近百种家族性遗传肿瘤综合征风险。</p>`,
      c2: `<p>实体瘤120基因检测产品采用高通量测序技术，检测实体瘤靶向治疗、免疫治疗、化疗和遗传风险密切相关的120个基因，同时评估微卫星不稳定性(MSI)和肿瘤突变负荷(TMB)。检测的突变类型包含单碱基替换(SNV)、小片段插入缺失(Indel)、拷贝数变异(CNV)和部分基因融合（Fusion）。适用癌种：胃癌、肺癌、结直肠癌、肝癌、乳腺癌、前列腺癌、胰腺癌、甲状腺癌等。</p>`
    },
    {
      id: 2,
      name: "lung",
      pre_id: 1,
      next_id: 3,
      title: '肺癌基因检测',
      img: 1,
      size: { w: '.51rem', h: '.51rem', t: 0, r: '0.59rem' },
      t1: '肺癌15基因检测',
      t2: '肺癌27基因检测',
      c1: `<p>肺癌15基因产品采用高通量测序技术，对15个肺癌靶向治疗相关基因特定多态位点进行高深度测序检测，为临床选择治疗药物提供参考。检测的突变类型包括碱基替换(SNV)、小片段插入缺失(Indel)、拷贝数变化(CNV)和部分基因重排（Fusion）。</p>`,
      c2: `<p>肺癌27基因产品采用高通量测序技术，对15个肺癌靶向治疗相关基因（涵盖NCCN指南推荐检测的8个基因）及12个化疗药物相关基因特定多态位点进行高深度测序检测，为临床选择治疗药物提供参考。检测的突变类型包括单碱基替换(SNV)、小片段插入缺失(Indel)、拷贝数变化(CNV)和部分基因重排（Fusion）。</p>`
    },
    {
      id: 3,
      name: "stomach",
      pre_id: 2,
      next_id: 4,
      size: { w: '.53rem', h: '.51rem', t: 0, r: '0.59rem' },
      title: '胃癌基因检测',
      t1: '胃癌60基因检测',
      c1: `<p>胃癌60基因检测产品采用高通量测序技术，检测胃癌靶向治疗、免疫治疗、化疗和遗传风险密切相关的60个基因和微卫星不稳定性(MSI)。检测的突变类型包含单碱基替换(SNV)、小片段插入缺失(Indel)、拷贝数变异(CNV)和部分基因融合（Fusion）。</p>`
    },
    {
      id: 4,
      name: "gynecological",
      pre_id: 3,
      next_id: 5,
      size: { w: '.58rem', h: '.51rem', t: 0, r: '0.59rem' },
      title: '妇科肿瘤基因检测',
      t1: '妇科肿瘤70基因检测',
      c1: `<p>妇科肿瘤 70 基因检测产品采用高通量测序技术，检测妇科肿瘤（包含乳腺癌、卵巢癌）靶向治疗、免疫治疗、化疗和遗传风险密切相关的 70 个基因和微卫星不稳定性(MSI)。检测的突变类型包含单碱基替换(SNV)、小片段插入缺失(Indel)、拷贝数变异(CNV)和部分基因融合（Fusion）。</p>`
    },
    {
      id: 5,
      name: "hereditary",
      pre_id: 4,
      next_id: 6,
      size: { w: '.51rem', h: '.51rem', t: 0, r: '0.59rem' },
      title: '遗传性肿瘤基因检测',
      t1: '遗传性肿瘤基因检测',
      c1: `<p>蓝沙生物遗传性肿瘤43基因检测产品覆盖28种遗传性肿瘤或遗传性肿瘤综合征，利用高通量测序技术结合目标区域探针捕获技术，一次性对43个遗传性肿瘤易感基因进行全面检测。该项检测既能为遗传性肿瘤患者查找致病基因，提供针对性治疗方案；又能提示患者家属患肿瘤的风险，协助其积极主动采取针对性的健康方案，做到未病先防。</p>

      <b>适应人群</b>
      <span>1、普通人群：正常体检，健康监控。</span>
      <span>2、肿瘤易感人群：有遗传性肿瘤家族史的人群；不健康生活方式人群；生活或工作环境中常接触有毒有害物质的人群。</span>
      <span>3、已患肿瘤人群：患者想是否是遗传因素导致的肿瘤；年轻的肿瘤患者人群(<50岁)；一个患者出现多个原发性肿瘤；罕见肿瘤患者。</span>
      
      <b>取样建议</b>
      <span>2mL唾液或者5mL血液。</span>`
    },
    {
      id: 6,
      name: "esophagus",
      pre_id: 5,
      next_id: 7,
      size: { w: '.6rem', h: '.51rem', t: 0, r: '0.59rem' },
      title: '食管癌基因检测',
      t1: '食管癌52基因检测',
      c1: `<p>食管癌52基因检测产品采用高通量测序技术，检测食管癌靶向治疗、免疫治疗和化疗密切相关的52个基因和微卫星不稳定性(MSI)。检测的突变类型包含单碱基替换(SNV)、小片段插入缺失(Indel)、拷贝数变异(CNV)和部分基因融合（Fusion）。</p>`
    },
    {
      id: 7,
      name: "GIST",
      pre_id: 6,
      next_id: 8,
      size: { w: '.48rem', h: '.78rem', t: '-.22rem', r: '0.59rem' },
      title: '胃肠间质瘤基因检测',
      t1: '胃肠间质瘤34基因检测',
      c1: `<p>胃肠道间质瘤34基因检测产品采用高通量测序技术，检测与胃肠道间质瘤发生高度相关的34个基因， 包含NCCN指南的KIT和PDGFRA基因，还包括与胃肠道间质瘤发生发展的其他基因。</p>`
    },
    {
      id: 8,
      name: "pancreas",
      pre_id: 7,
      next_id: 9,
      size: { w: '.6rem', h: '.24rem', t: '0.3rem', r: '.4rem' },
      title: '胰腺癌基因检测',
      t1: '胰腺癌60基因检测',
      c1: `<p>胰腺癌60基因检测产品采用高通量测序技术，检测胰腺癌靶向治疗、免疫治疗、化疗和遗传风险密切相关的60个基因和微卫星不稳定性（MSI）。检测的突变类型包含单碱基替换（SNV）、小片段插入缺失（Indel）、拷贝数变异（CNV）和部分基因融合（Fusion）。</p>`
    },
    {
      id: 9,
      name: "CRC",
      pre_id: 8,
      next_id: 10,
      size: { w: '.5rem', h: '.51rem', t: 0, r: '0.59rem' },
      title: '结直肠癌基因检测',
      t1: '结直肠癌60基因检测',
      c1: `<p>结直肠癌60基因检测产品采用高通量测序技术，检测结直肠癌靶向治疗、免疫治疗、化疗和遗传风险密切相关的60个基因和微卫星不稳定性(MSI)。检测的突变类型包含单碱基替换(SNV)、小片段插入缺失(Indel)、拷贝数变异(CNV)和部分基因融合（Fusion）。</p>`
    },
    {
      id: 10,
      name: "MRD",
      pre_id: 9,
      size: { w: '.48rem', h: '.49rem', t: '0.05rem', r: '0.59rem' },
      title: '术后微小残留病灶（MRD）监控',
      t1: '术后微小残留病灶（MRD）监控',
      c1: `<p> 癌症中的微小残留病灶 (Minimal Residual Disease, MRD) 是指癌症治疗后仍存在于患者体内、但影像学方法无法检出的残留肿瘤细胞或者微小病灶，属于肿瘤进展的隐匿阶段。残留的癌细胞数量可能很少，暂时不会引起任何体征或症状，但它们可能导致未来肿瘤的进展或复发转移，是肿瘤复发的直接原因。</p>`,
      c2: `<p><b>检测意义：</b>通过液体活检对癌来源分子异常进行MRD监测，可评估癌症患者围术期微小残留病灶的状态，辅助临床医生对患者进行复发风险分层评估，预测并评估辅助治疗的疗效，判断转移复发病灶来源，制定个性化临床指导方案。</p>
        <b>MRD优势：</b>
        <span>1.在实体肿瘤领域，基于ctDNA指导的MRD评估，优于传统的临床或影像学方法，并在预测疾病复发风险等方面具有较高的灵敏度和特异性。</span>
        <span>2.基于ctDNA指导的实体瘤MRD可适用鼻咽癌、结肠癌、直肠癌、乳腺癌、胰腺癌、肺癌等多种实体肿瘤。</span>
        <b>检测时间点：</b>
        <span>何时检测MRD需要根据患者疾病的特定因素来决定，一般选择如下：</span>
        <span>1.在联合治疗的最后一个周期后进行检测；</span>
        <span>2.在骨髓移植后进行检测；</span>
        <span>3.在治疗期间进行检测确定缓解深度；</span>
        <span>4.在一年的维持治疗后进行检测；</span>
        <span>5.在治疗结束后定期进行检测或在其他特定时间进行检测</span>
        <p><strong>检测样本：</strong>血液样本（静脉）</p>`
    }
  ],

  // 没有上一篇了
  no_pre: '没有上一篇了',
  // 没有下一篇了
  no_next: '没有下一篇了',

  // 加入我们
  recruitment: {
    recruitment1: '招聘',
    recruitment2: 'RECRUITMENT',
    social1: '社会招聘',
    social2: 'Social recruitment',
    socialLabel: '社招',
    campus1: '校园招聘',
    campus2: 'Campus Recruitment',
    campusLabel: '校招',
    // 筛选条件
    condition: {
      title: '筛选条件'
    },
    list: {
      title: '职位列表'
    }
  }
}

export default zh


// WEBPACK FOOTER //
// ./src/i18n/zh.js